import { render, staticRenderFns } from "./addSurplusTemp.vue?vue&type=template&id=35cc4492&scoped=true&"
import script from "./addSurplusTemp.vue?vue&type=script&lang=js&"
export * from "./addSurplusTemp.vue?vue&type=script&lang=js&"
import style0 from "./addSurplusTemp.vue?vue&type=style&index=0&id=35cc4492&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc4492",
  null
  
)

export default component.exports